import FactoidVacancy from './FactoidVacancy';
export default FactoidVacancy;